export const formatPrice = (x) => {
  return parseFloat(x).toFixed(2);
};



// WEBPACK FOOTER //
// ./src/components/Cart/util.js